import React, { useState } from 'react';
import MDEditor from '@uiw/react-md-editor';
import './MarkdownTextArea.css';
import { FormText, Row, Col, Accordion, Card, Button } from 'react-bootstrap';

interface IMarkdownTextArea {
  readonly name: string;
  value: string;
  setValue: (x: number, y: {}) => void;
  readonly identifier: number;
  readonly maxCharacters?: number;
}

const MarkdownTextAreaInput: React.FC<IMarkdownTextArea> = (props) => {
  const maxCharacters = props.maxCharacters || -1;
  const [reachCharacterLimit, setReachCharacterLimit] = useState(false);

  const handleChange = (description: any) => {
    setReachCharacterLimit(false);
    if (description.length <= maxCharacters || maxCharacters === -1) {
      props.setValue(props.identifier, {
        [props.name]: description,
      });
    } else {
      setReachCharacterLimit(true);
    }
  };

  return (
    <div className="Markdown-TextArea container pl-0 pr-0">
      <MDEditor
        value={props.value}
        onChange={handleChange}
        preview="edit"
        height={300}
      />
      <FormText className="text-muted text-right mb-2 ">
        <Row>
          <Col
            md={4}
            sm={4}
            className={`
                        text-left 
                        ${reachCharacterLimit && 'reachCharacterLimit'}
                        ${
                          props.value?.length / maxCharacters > 0.85 &&
                          props.value?.length / maxCharacters < 1
                            ? 'aboutToReachCharacterLimit'
                            : ''
                        }
                    `}
          >
            {/* <span>{props.value?.length || 0} characters</span> */}
          </Col>
          {props.maxCharacters === -1 ? (
            <Col className="text-right">
              <span>{props.value?.length || 0} characters</span>
              {/* <span>No limit, Write as much as you want</span> */}
            </Col>
          ) : (
            <Col className="text-right">
              <span>
                {props.value?.length} / {maxCharacters} characters.
              </span>
            </Col>
          )}
        </Row>
      </FormText>
      <Accordion>
        <Card>
          <Card.Header>
            <Accordion.Toggle as={Button} variant="link" eventKey="0">
              Show Markdown Preview
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body className="p-0">
              <div className="Markdown-TextArea-Preview-Section">
                <MDEditor.Markdown
                  source={props.value}
                  className="Markdown-TextArea-Preview"
                />
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};
export default MarkdownTextAreaInput;
